export default function getResource(label, vars = []) {
    const resources = {
        title: 'Adhérez aux alertes par texto de Sephora',
        description: 'pour profiter d’un accès exclusif à des offres beauté et des mises à jour.',
        buttonText: 'Envoyez-moi des alertes par textos de Sephora'
    };

    return resources[label];
}
